const RepeatingRowComponent = {
    templateUrl: '/formViewer/structure/repeatingRow/repeatingRow.tpl.html',
    controller: 'repeatingRowController',
    bindings: {
        row: '<',
        hideRowNumbers: '<',
        configurable: '<'
    }
};

angular.module('umFormViewer')
    .component('uiRepeatingRow', RepeatingRowComponent);
